/*
 * 存储相关函数
 * */
'use strict';
var LOCAL_STORE = {};

exports.get = function (k) {
  try {
    var storage = window.localStorage || {};
    return storage[k];
  } catch (e) {
    console.error(e);
    return LOCAL_STORE[k];
  }
};

exports.set = function (k, v) {
  try {
    window.localStorage[k] = v;
  } catch (e) {
    console.error(e);
    LOCAL_STORE[k] = v;
  }
};


// WEBPACK FOOTER //
// ./src/helper/storeHelper.js